// What a micrograph shows (microscopy_images.structure, migration 0066;
// routes/microscopy.py STRUCTURES, word for word). The four the lab names
// first, then the rest of the Stage 4 feature list. Labels live in the scan
// catalogue (scan:structure.<key>, plus scan:structure.untyped for none).
// Shared by the hub's culture card (grouping, the inline type select) and its
// micrograph form.
export const MICRO_STRUCTURES = ['spore', 'hypha', 'conidiophore', 'clamp_connection', 'basidium', 'cystidium', 'other'];

/** The reason written to the audit log when a type is chosen on the culture card. */
export const CULTURE_CARD_REASON = 'typed from the culture card';
